<template>
  <div id="half_month_log">
    <van-nav-bar
      :title="$t('title.month_statistics_log')"
      safe-area-inset-top
      left-arrow
      fixed
      z-index="5"
      :placeholder="true"
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #right>
        <van-icon name="filter-o" size="18" color="#1A1A1A"/>
      </template>
    </van-nav-bar>

    <van-row>
      <van-col span="24">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('other.there_is_no_more')"
          @load="onLoad"
        >
          <van-index-bar :index-list="indexList">
            <van-col span="22" offset="1" v-if="SelStartTime">
              <van-col span="24" class="half_month_log_to_time">{{ SelStartTime }} to {{ SelEndTime }}</van-col>
              <van-col span="24" class="half_month_log_to_center">{{ $t('column.total_revenue') }}: {{ earnings }}</van-col>
              <van-col span="12" class="half_month_log_to_center">{{ $t('column.Live_durntion') }} {{ live_duration }}</van-col>
              <van-col span="12" class="half_month_log_to_center">{{ $t('column.voice_room') }}: {{ voice_duration }}</van-col>
              <van-col span="12" class="half_month_log_to_center">{{ $t('column.total_duration') }} {{ duration }}</van-col>
              <van-col span="12" class="half_month_log_to_center">{{ $t('column.valid_days') }}: {{ day_effective }}</van-col>
            </van-col>
            <van-col span="24" v-for="item in list" :key="item.time">
              <van-index-anchor class="half_month_log_anchor">{{ item.time }}</van-index-anchor>
              <van-cell v-for="t in item.list" :key="t + 'a'" class="half_month_log_border">
                <van-col span="18" class="half_month_log_earnings">
                  {{ $t('other.profit') }}: {{ t.earnings }}
                </van-col>
                <van-col span="6" class="half_month_log_time">{{ t.create_time }}</van-col>
                <van-col span="12" class="half_month_log_left">{{ $t('column.Live_durntion') }}: {{ t.live_duration }}</van-col>
                <van-col span="12" class="half_month_log_right">{{ $t('column.voice_room') }}: {{ t.voice_duration }}</van-col>
                <van-col span="12" class="half_month_log_left">{{ $t('column.total_duration') }}: {{ t.duration }}</van-col>
                <van-col span="12" class="half_month_log_right"> {{ $t('column.valid_days') }}: {{ t.day_effective }}</van-col>

              </van-cell>
            </van-col>
          </van-index-bar>
        </van-list>
      </van-col>
    </van-row>
    <van-popup v-model="show" position="bottom" :style="{ height: '80%' }" round safe-area-inset-bottom >
      <van-row class="half_month_log_sheet">
        <van-col span="5" offset="1" class="half_month_log_sheet_center half_month_log_sheet_left_center" @click="cancel"> {{ $t('btn.cancel') }} </van-col>
        <van-col span="12" class="half_month_log_sheet_center half_month_log_sheet_c_center"> {{ $t('other.time') }}  </van-col>
        <van-col span="5" class="half_month_log_sheet_center half_month_log_sheet_right_center" @click="confirm">  {{ $t('btn.confirm') }} </van-col>
        <van-col span="16" offset="4">
          <van-tabs type="card" v-model="active" @click="onTabClick">
            <van-tab :title="$t('other.days')"></van-tab>
            <van-tab :title="$t('other.month')"></van-tab>
          </van-tabs>
        </van-col>
        <van-col span="8" offset="3" class="half_month_log_sheet_time" @click="clickActiveTime(0)">  {{ StartTime }}  </van-col>
        <van-col span="2" class="half_month_log_sheet_c_time">  -  </van-col>
        <van-col span="8" class="half_month_log_sheet_time" @click="clickActiveTime(1)"> {{ EndTime }} </van-col>
        <van-col span="24">
          <van-datetime-picker
            class="date_picker"
            v-model="currentDate"
            type="year-month"
            :min-date="minDate"
            :max-date="maxDate"
            @change="currentDateChange"
            v-if="active === 1"
          />
          <van-datetime-picker
            class="date_picker"
            v-model="currentDate"
            type="date"
            :min-date="minDate"
            :max-date="maxDate"
            @change="currentDateChange"
            v-else
          />
        </van-col>
      </van-row>
    </van-popup>
  </div>
</template>

<script>

import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"
export default {
  filters: {},
  data() {
    return {
      indexList: [],
      list: [],
      loading: false,
      finished: false,
      active: 0,
      page: 1,
      show: false,
      minDate: new Date(2023, 0, 1),
      maxDate: new Date(2063, 10, 1),
      currentDate:new Date(2023, 8, 21),
      active_time: 0,
      StartTime: '',
      EndTime: '',
      SelStartTime: '',
      SelEndTime: '',
      day_effective: '',
      duration: '',
      earnings: '',
      voice_duration: '',
      live_duration: ''
    }
  },
  created: function() {
    //
    // this.list.push({
    //   'time':'2012-08',
    //   'list': [
    //     {'earnings': '300','create_time':'2012-02-01','live_duration':'12','voice_duration':'22','duration':'33','day_effective':'3'},
    //     {'earnings': '300','create_time':'2012-02-01','live_duration':'12','voice_duration':'22','duration':'33','day_effective':'3'},
    //     {'earnings': '300','create_time':'2012-02-01','live_duration':'12','voice_duration':'22','duration':'33','day_effective':'3'},
    //     {'earnings': '300','create_time':'2012-02-01','live_duration':'12','voice_duration':'22','duration':'33','day_effective':'3'},
    //     {'earnings': '300','create_time':'2012-02-01','live_duration':'12','voice_duration':'22','duration':'33','day_effective':'3'},
    //     {'earnings': '300','create_time':'2012-02-01','live_duration':'12','voice_duration':'22','duration':'33','day_effective':'3'},
    //     {'earnings': '300','create_time':'2012-02-01','live_duration':'12','voice_duration':'22','duration':'33','day_effective':'3'},
    //     {'earnings': '300','create_time':'2012-02-01','live_duration':'12','voice_duration':'22','duration':'33','day_effective':'3'},
    //     {'earnings': '300','create_time':'2012-02-01','live_duration':'12','voice_duration':'22','duration':'33','day_effective':'3'},
    //   ]
    // })
  },
  methods: {
    onLoad() {
      // 异步更新数据
      this.convert();
    },
    cancel() {
      this.show = false
    },
    onlogin(){
      // 登录失败重新登录 user_login_status
      window.location.href="live://user/logout"
    },
    confirm() {
      this.SelStartTime = this.StartTime
      this.SelEndTime = this.EndTime
      this.page = 1
      this.show = false
      this.convert()
    },
    clickActiveTime(t) {
      this.active_time = t
      this.currentDate = t == 1 ? new Date(this.EndTime) : new Date(this.StartTime)
    },
    currentDateChange() {
      if (this.active_time == 0) {
        this.StartTime = this.timeFormat(this.currentDate)
      } else {
        this.EndTime = this.timeFormat(this.currentDate)
      }
    },
    timeFormat(time) { //时间格式化 2019-09-08
      console.log(time)
      let dt = new Date(time)
      let year = dt.getFullYear();
      let month = dt.getMonth() + 1;
      console.log(this.active)
      if (this.active == 1){
        return year + '-' + month
      } else {
        let day = dt.getDate();
        return year + '-' + month + '-' +day
      }

    },
    onTabClick() {
      this.active_time = 0
      this.StartTime = ''
      this.EndTime = ''
    },
    onClickLeft() {
      const token = this.$route.query.token
      this.$router.push({path: '/month_statistics', query: {token: token}})
    },
    onClickRight() {
      this.active_time = 0
      this.StartTime = ''
      this.EndTime = ''
      this.show = true
    },
    convert() {
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user&act=get_day_earnings", {
        params : {
          token: token,
          time_type: this.active == 0 ? 1 : 2,
          starttime: this.SelStartTime,
          endtime: this.SelEndTime,
          page: this.page
        }
      }).then(res =>{
        console.log(res.data)
        // 加载状态结束
        this.loading = false
        if (res.data.status === 0) {
          this.onlogin()
          Toast(res.data.error)
          this.finished = true
          return false
        }else{
          if (this.page == 1) {
            this.list = []
            this.finished = false
          }
          const list = res.data.data.month_list
          this.earnings = res.data.data.earnings
          this.duration = res.data.data.duration
          this.live_duration = res.data.data.live_duration
          this.voice_duration = res.data.data.voice_duration
          this.day_effective = res.data.data.day_effective
          for (let i = 0; i < list.length; i++) {
            if (i == 0) {
              if (this.list.length > 0 && this.list[this.list.length - 1]['time'] == list[i]['time']) {
                for(let j = 0; j < list[i]['list'].length; j++) {
                  this.list[this.list.length - 1]['list'].push(list[i]['list'][j])
                }
              }else{
                this.list.push(list[i])
              }
            }else{
              this.list.push(list[i])
            }
          }
          // 数据全部加载完成
          if (list.length <= 0) {
            this.finished = true
          }
          this.page ++
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/month_statistics_log.vue